import { FC } from "react"
import { Box } from "@mui/material"
import { DayKey } from "../../model/mskCalendar"
import { DayColumn } from "../../model/period"
import {
  DAY_COL_W,
  ROW_H,
  STAFF_COL_W,
  TOTAL_COL_W,
  Z,
  dayBorderLeftSx,
  gridBorderColorStrong,
  weekendBg,
} from "./gridGeometry"

interface GridTotalsRowProps {
  days: DayColumn[]
  totalsByDay: Map<DayKey, number>
  grandTotal: number
}

/** Строка «Итог» — залипает снизу; её углы — sticky-слои внутри её собственного контекста. */
export const GridTotalsRow: FC<GridTotalsRowProps> = ({
  days,
  totalsByDay,
  grandTotal,
}) => (
  <Box
    sx={{
      position: "sticky",
      bottom: 0,
      zIndex: Z.totalsRow,
      display: "flex",
      height: ROW_H,
      bgcolor: "background.paper", // непрозрачный фон обязателен
    }}
  >
    <Box
      sx={{
        position: "sticky",
        left: 0,
        zIndex: Z.stickyInHeader,
        width: STAFF_COL_W,
        flex: "0 0 auto",
        display: "flex",
        alignItems: "center",
        px: 1,
        fontWeight: 600,
        bgcolor: "background.paper",
        borderRight: "1px solid",
        borderTop: "2px solid",
        borderColor: gridBorderColorStrong,
      }}
    >
      Итог
    </Box>
    {days.map((day) => (
      <Box
        key={day.key}
        data-testid={`total-day-${day.key}`}
        sx={{
          width: DAY_COL_W,
          flex: "0 0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 16,
          fontWeight: 600,
          bgcolor: day.isWeekend ? weekendBg : undefined,
          borderTop: "2px solid",
          borderColor: gridBorderColorStrong,
          ...dayBorderLeftSx(day.weekday),
        }}
      >
        {totalsByDay.get(day.key) ?? 0}
      </Box>
    ))}
    <Box
      data-testid="total-grand"
      sx={{
        position: "sticky",
        right: 0,
        zIndex: Z.stickyInHeader,
        width: TOTAL_COL_W,
        flex: "0 0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        bgcolor: "background.paper",
        borderLeft: "1px solid",
        borderTop: "2px solid",
        borderColor: gridBorderColorStrong,
      }}
    >
      {grandTotal}
    </Box>
  </Box>
)
